import sort from '@fno/lib/sort-array-by-object-properties.js'

export const mutateStepArrayToMap = ({ task }) => {
    task.attributes.steps = task.attributes.steps.reduce((map, step, index) => {
        step.$index = index
        map[step.id] = step
        return map
    }, {})
}

export const mutateStepMapToArray = ({ task }) => {
    task.attributes.steps = sort({
        objects: Object
            .keys(task.attributes.steps)
            .map(key => task.attributes.steps[key]),
        sortableColumns: [ '$index' ]
    }).map(step => {
        delete step.$index
        return step
    })
}
